window.lensProducts = {
"Premium Thin": 48694003237019,
"Ultra Thin": 48694040789147,
"Progressive": 48694057107611
};

window.addonProducts = {
"Anti Reflective": 48687786393755,
"Blue Filter": 48687781576859,
"UV": 48687774498971,
"Scratch Resistant": 48687777218715,
"Transitions": 48687771418779
};

if (!customElements.get('product-form')) {
customElements.define(
'product-form',
class ProductForm extends HTMLElement {
constructor() {
super();

this.form = this.querySelector('form');

// 🔥 ONLY continue if this is a real product form
if (!this.form || this.form.getAttribute('action')?.includes('search')) return;

const variantInput = this.form.querySelector('[name="id"]');
if (variantInput) variantInput.disabled = false;

this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

this.cart =
document.querySelector('cart-notification') ||
document.querySelector('cart-drawer');

this.submitButton = this.querySelector('[type="submit"]');
this.submitButtonText = this.submitButton?.querySelector('span');

this.hideErrors = this.dataset.hideErrors === 'true';
}

onSubmitHandler(evt) {
evt.preventDefault();

if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

this.handleErrorMessage();

this.submitButton.setAttribute('aria-disabled', true);
this.submitButton.classList.add('loading');
this.querySelector('.loading__spinner')?.classList.remove('hidden');

(async () => {
try {
const formData = new FormData(this.form);
const frameVariantId = formData.get('id');

const bundleId = Date.now();

const lensChoice =
document.querySelector('input[name="lens_choice"]:checked')?.value;

const selectedAddons =
Array.from(document.querySelectorAll('input[name="addon_choice"]:checked'))
.map(el => el.value);

const properties = Object.fromEntries(
[...formData.entries()].filter(([key]) =>
key.startsWith('properties[')
)
);

properties["Lens Choice"] = lensChoice || "Standard Included";
properties["Add Ons"] = selectedAddons.join(', ');

const items = [];

// FRAME
items.push({
id: frameVariantId,
quantity: 1,
properties: {
...properties,
"_bundle_id": Date.now()
}
});

// LENS
if (lensChoice && window.lensProducts?.[lensChoice]) {
items.push({
id: window.lensProducts[lensChoice],
quantity: 1,
properties: {
_bundle_id: bundleId
}
});
}

// ADD-ONS
selectedAddons.forEach(addon => {
const addonId = window.addonProducts?.[addon];

if (addonId) {
items.push({
id: addonId,
quantity: 1,
properties: {
_bundle_id: bundleId
}
});
}
});

const response = await fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ items })
});

await response.json();

window.location = '/cart';
return;

} catch (err) {
console.error('Add to cart error:', err);
this.handleErrorMessage(err.message || "Cart error");
} finally {
this.submitButton?.classList.remove('loading');
this.submitButton?.removeAttribute('aria-disabled');
this.querySelector('.loading__spinner')?.classList.add('hidden');
}
})();
}

handleErrorMessage(msg = false) {
if (this.hideErrors) return;

const wrapper =
this.errorMessageWrapper ||
this.querySelector('.product-form__error-message-wrapper');

if (!wrapper) return;

const message =
this.errorMessage ||
wrapper.querySelector('.product-form__error-message');

wrapper.toggleAttribute('hidden', !msg);

if (msg) message.textContent = msg;
}
}
);
}